///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, input } from '@angular/core';
import { GtthHistoryService } from '../../logical-topology/engine/history-service';

@Component({
    selector: 'winde-link-pointer',
    template: `<a class="btn btn-link no-padding align-baseline" tabindex="1" style="color: #3e8acc" (click)="showLinkOnMap()">{{
        linkData().name
    }}</a>`
})
export class GtthLinkPointerComponent {
    linkData = input<{
        nodeFrom: string;
        nodeTo: string;
        name: string;
    }>();

    constructor(private readonly historyService: GtthHistoryService) {}

    showLinkOnMap() {
        const nodeFrom = this.historyService.logicalTopology.getStationByName(this.linkData().nodeFrom);
        const nodeTo = this.historyService.logicalTopology.getStationByName(this.linkData().nodeTo);
        const linkCenter = google.maps.geometry.spherical.interpolate(
            nodeFrom.getPosition().toLatLng(google),
            nodeTo.getPosition().toLatLng(google),
            0.5
        );

        this.historyService.mapSetCenterAndZoom(linkCenter.lat(), linkCenter.lng());

        this.historyService.ngZone.runOutsideAngular(() => {
            this.historyService.addSearchMarker({ lat: linkCenter.lat(), lng: linkCenter.lng() }, this.linkData().name + ' pointer');
        });
    }
}
